import { render, staticRenderFns } from "./odm-poster.vue?vue&type=template&id=592f7366&scoped=true"
import script from "./odm-poster.vue?vue&type=script&lang=js"
export * from "./odm-poster.vue?vue&type=script&lang=js"
import style0 from "./odm-poster.vue?vue&type=style&index=0&id=592f7366&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592f7366",
  null
  
)

export default component.exports